import React from 'react';
import {
  bgColors,
  getTextColorFromBackgroundColor,
} from '@teetsh/app/src/components/colors';
import tw from 'twin.macro';
import { Tag } from 'types/event';

interface Props {
  value: Tag;
}

export function TagItem(props: Props) {
  const { value } = props;
  return (
    <span
      css={[
        getTextColorFromBackgroundColor(value.color),
        bgColors(value.color),
        tw`truncate text-sm font-medium rounded-md px-3 py-1.5`,
      ]}
    >
      {value.title}
    </span>
  );
}
